import BaseRoute from 'seshy/routes/base';
import { action } from '@ember/object';

export default class AuthenticatedTeamsListRoute extends BaseRoute {
  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    let listIndexController = this.controllerFor(
      'authenticated.teams.list.index',
    );
    listIndexController.set('searchValue', model.searchValue);
  }

  @action
  propagateSearch(searchValue) {
    console.log('propagateSearch', searchValue);
    this.controllerFor('authenticated.teams.list.index').set(
      'searchValue',
      searchValue,
    );
  }
}
